<template>
  <div class="square-buttons-row">
    <square-button
      v-bind="firstButtonProps"
      @click="$emit('click', 0)"
    />
    <square-button
      v-bind="secondButtonProps"
      @click="$emit('click', 1)"
    />
    <square-button
      v-bind="thirdButtonProps"
      @click="$emit('click', 2)"
    />
  </div>
</template>

<script>
import SquareButton, { SquareButtonProps } from './SquareButton';

export default {
  name: 'SquareButtonsRow',
  components: {
    SquareButton,
  },
  props: {
    firstButtonProps: SquareButtonProps,
    secondButtonProps: SquareButtonProps,
    thirdButtonProps: SquareButtonProps,
  },
  data() {
    return {
      selectedIndex: this.initialSelectionIndex,
    };
  },
  methods: {
    onSelect(index) {
      this.selectedIndex = index;
      this.$emit('select', index);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../scss/spacings';

.square-buttons-row {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0 $ri-spacing-ml;
}
</style>
